var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import auth0 from "auth0-js";

export var AUTH_DEFAULT_CONFIG = {
    redirectUri: window.location.href,
    audience: "api://api.spscommerce.com/",
    responseType: "token",
    realm: "identity"
};

var Auth = function () {
    function Auth(userConfig, tokenUpdateHandler) {
        var _this = this;

        _classCallCheck(this, Auth);

        this.scheduleRenewal = function () {
            // we only want 1 timeout to be running at a time so we will clear any
            // previous timeouts that may still be running
            clearTimeout(_this.tokenRenewalTimeout);
            var expiresAt = JSON.parse(localStorage.getItem("expires_at"));
            var delay = expiresAt - Date.now();
            if (expiresAt) {
                if (delay > 0) {
                    _this.tokenRenewalTimeout = setTimeout(function () {
                        _this.renewToken();
                    }, delay);
                } else if (delay <= 0) {
                    // call checkSession if token in localStorage has already expired
                    _this.renewToken();
                }
            }
        };

        this.renewToken = function () {
            _this.auth0.checkSession({}, function (err, result) {
                if (err) {
                    console.warn(err);
                    //If check session fails, we will want to call logout to remove any erroneous
                    //local storage values and clear current user
                    _this.logout();
                } else {
                    _this.setSession(result, _this.tokenUpdateHandler);
                    _this.scheduleRenewal();
                }
            });
        };

        var defaultConfig = {
            redirectUri: AUTH_DEFAULT_CONFIG.redirectUri,
            audience: AUTH_DEFAULT_CONFIG.audience,
            responseType: AUTH_DEFAULT_CONFIG.responseType
        };

        var _defaultConfig$userCo = _extends({}, defaultConfig, userConfig),
            domain = _defaultConfig$userCo.domain,
            clientID = _defaultConfig$userCo.clientID,
            redirectUri = _defaultConfig$userCo.redirectUri,
            audience = _defaultConfig$userCo.audience,
            responseType = _defaultConfig$userCo.responseType;

        if (domain && clientID) {
            this.auth0 = new auth0.WebAuth({
                domain: domain,
                clientID: clientID,
                redirectUri: redirectUri,
                audience: audience,
                responseType: responseType
            });
            this.login = this.login.bind(this);
            this.logout = this.logout.bind(this);
            this.handleAuthentication = this.handleAuthentication.bind(this);
            this.isAuthenticated = this.isAuthenticated.bind(this);
            this.tokenUpdateHandler = tokenUpdateHandler;
            this.redirectUri = redirectUri;
            this.realm = userConfig.realm === undefined || userConfig.realm === '' ? AUTH_DEFAULT_CONFIG.realm : userConfig.realm;
            window.onfocus = function () {
                _this.checkToken();
            };
            window.onblur = function () {
                clearTimeout(_this.tokenRenewalTimeout);
            };
            if (this.isAuthenticated()) {
                // Found a valid session, schedule renewal since the token will still work
                this.scheduleRenewal();
            } else if (this.hasToken()) {
                // Have an expired token, remove it
                this.clearSession();
            } // If no token is present no action is required
        } else {
            throw new Error("WebAuth requires a domain and clientID");
        }
    }

    Auth.prototype.login = function login(config) {
        if (config === undefined) {
            config = { realm: this.realm };
        } else {
            config.realm = this.realm;
        }
        this.auth0.authorize(config);
    };

    Auth.prototype.checkToken = function checkToken() {
        if (this.hasToken()) {
            if (!this.isAuthenticated()) {
                this.renewToken();
                return;
            } else {
                this.scheduleRenewal();
            }
        }
    };

    Auth.prototype.handleAuthentication = function handleAuthentication(callback, errorHandler) {
        var _this2 = this;

        this.auth0.parseHash(function (err, authResult) {
            if (err) {
                if (errorHandler) {
                    errorHandler(err);
                } else {
                    throw new Error("Please pass an error handler to the handleAuthentication function");
                }
                console.warn(err);
            }
            if (!err && authResult && authResult.accessToken) {
                _this2.setSession(authResult, callback);
                _this2.scheduleRenewal();
            }
        });
    };

    Auth.prototype.setSession = function setSession(authResult, callback) {
        // Set the time that the access token will expire at
        var expiresAt = JSON.stringify(authResult.expiresIn * 1000 + new Date().getTime());
        localStorage.setItem("access_token", authResult.accessToken);
        localStorage.setItem("expires_at", expiresAt);
        if (callback) {
            callback(authResult);
        }
    };

    Auth.prototype.clearSession = function clearSession() {
        // Clear access token and ID token from local storage
        localStorage.removeItem("access_token");
        localStorage.removeItem("expires_at");
        clearTimeout(this.tokenRenewalTimeout);
    };

    Auth.prototype.logout = function logout(config) {
        var options = _extends({ returnTo: this.redirectUri }, config);
        this.clearSession();
        this.auth0.logout(options);
    };

    Auth.prototype.hasToken = function hasToken() {
        return !!localStorage.getItem("access_token");
    };

    Auth.prototype.isAuthenticated = function isAuthenticated() {
        // Check whether the current time is past the
        // access token's expiry time
        var expiresAt = void 0;
        try {
            expiresAt = JSON.parse(localStorage.getItem("expires_at"));
        } catch (e) {
            console.warn("Could not parse the value for 'expires_at' from localStorage");
        }
        if (!expiresAt) {
            return false;
        }
        return new Date().getTime() < expiresAt;
    };

    return Auth;
}();

export { Auth as default };